const PageData = {
  appFrame: undefined
}

export default PageData



// WEBPACK FOOTER //
// ./src/shared/utils/PageData.js